<div class="container-fluid p-4 p-md-5">
    <app-modal-periodo
        (periodoSeleccionado)="
            onPeriodoSeleccionado($event)
        "></app-modal-periodo>
    <div class="mb-5">
        <div
            class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
            <div class="d-flex align-items-center">
                <h3 class="fw-semibold text-success mb-0 me-3">
                    Carga y consulta de reportes
                </h3>
                <button
                    type="button"
                    class="btn btn-success rounded-circle d-flex align-items-center justify-content-center icon-button"
                    (click)="mostrarTexto()"
                    aria-label="Mostrar información">
                    <i class="fas fa-question"></i>
                </button>
            </div>
        </div>
        <div class="col-md-12 d-flex align-items-center p-0">
            <h2 class="mb-0" style="color: black; font-weight: bold">
                Registro de ventas e inventario
            </h2>
            <button
                type="button"
                class="btn btn-success ml-3"
                (click)="downloadInstructive()">
                Descargar instructivo
            </button>
        </div>

        <div class="row mt-2 g-3">
            <!-- Primer Card -->
            <div class="col-xl-4 col-lg-6">
                <div class="card shadow-sm">
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title fw-bold">
                            Reporte por carga masiva
                        </h5>
                        <p class="card-text text-muted">
                            {{ 'reporte.cuerpoCargaMasiva' | translate }}
                        </p>
                        <div class="mt-auto d-grid gap-2 d-sm-flex">
                            <button
                                type="button"
                                class="btn btn-outline-success"
                                (click)="downloadReport()">
                                <i class="fas fa-download me-2"></i>
                                Descargar plantilla
                            </button>
                            <button
                                type="button"
                                class="btn btn-success"
                                (click)="openMassUploadModal(modalLoadReport)">
                                <i class="fas fa-upload me-2"></i>
                                Carga masiva
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Segundo Card -->
            <!-- Se oculta la funcionalidad para acceder a carga individual de comercializadores -->
            <!-- <div class="col-xl-4 col-lg-6">
                <div class="card shadow-sm">
                    <div
                        class="card-body d-flex flex-column h-100"
                        style="z-index: 10">
                        <h5 class="card-title fw-bold">
                            Reporte manual individual
                        </h5>
                        <p class="card-text">
                            {{ 'reporte.textoCarguaIndividual' | translate }}
                        </p>
                        <div
                            class="d-flex justify-content-end mt-auto"
                            *ngIf="ultimoObjetoCreado">
                            <app-button
                                label="Continuar reporte"
                                variant="success"
                                iconClass="fas fa-upload"
                                (clicked)="continuarReporte()"></app-button>
                        </div>
                        <div
                            class="d-flex justify-content-end mt-auto"
                            *ngIf="!ultimoObjetoCreado">
                            <app-button
                                label="Crear reporte"
                                variant="success"
                                iconClass="fas fa-upload"
                                (clicked)="reporteManual()"></app-button>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Tercera Card -->
            <div class="col-xl-4 col-lg-6">
                <div class="card shadow-sm">
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title fw-bold">
                            Consulta de cargas históricas
                        </h5>
                        <p class="card-text text-muted">
                            {{ 'reporte.textoCargueHistorico' | translate }}
                        </p>
                        <div class="d-flex mt-auto justify-content-end">
                            <button
                                type="button"
                                class="btn btn-outline-success"
                                (click)="irConsultaReportes()">
                                <i class="fas fa-search me-2"></i>
                                Consultar reportes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SECCIÓN 2: Consulta de Reportes y Certificados -->
    <div>
        <div
            class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
            <h3 class="fw-semibold text-success mb-0">
                Consultar reportes y certificados
            </h3>
            <span class="text-muted small">
                Empresa:
                <strong class="text-dark">{{ empresaSeleccionada }}</strong>
            </span>
        </div>

        <ul class="nav nav-tabs" id="reportesTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link active"
                    id="tabReportes-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tabReportesContent"
                    type="button"
                    role="tab"
                    aria-controls="tabReportesContent"
                    aria-selected="true">
                    Reportes
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="tabCertificados-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tabCertificadosContent"
                    type="button"
                    role="tab"
                    aria-controls="tabCertificadosContent"
                    aria-selected="false"
                    (click)="showCertificates()">
                    Certificados
                </button>
            </li>
        </ul>

        <div class="tab-content mt-3">
            <!-- Tab Reportes -->
            <div
                class="tab-pane fade show active"
                id="tabReportesContent"
                role="tabpanel">
                <div class="row g-3 mb-3">
                    <!-- Selector de Año -->
                    <div class="col-md-3">
                        <label for="selectAnio" class="form-label fw-semibold">
                            Año:
                        </label>
                        <select
                            class="form-select"
                            id="selectAnio"
                            [(ngModel)]="selectedYear"
                            (change)="historyReport()">
                            <option *ngFor="let year of years" [value]="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>

                    <!-- Selector de Mes (solo Grande) -->
                    <div class="col-md-3" *ngIf="esGrande">
                        <label for="selectMes" class="form-label fw-semibold">
                            Mes:
                        </label>
                        <select
                            class="form-select"
                            id="selectMes"
                            [(ngModel)]="selectedMonth"
                            (change)="historyReport()">
                            <option
                                *ngFor="let month of months"
                                [value]="month.value">
                                {{ month.name }}
                            </option>
                        </select>
                    </div>

                    <!-- Selector de Trimestre (solo Mediano) -->
                    <div class="col-md-3" *ngIf="esMediano">
                        <label
                            for="selectTrimestre"
                            class="form-label fw-semibold">
                            Trimestre:
                        </label>
                        <select
                            class="form-select"
                            id="selectTrimestre"
                            [(ngModel)]="selectedTrimestre"
                            (change)="historyReport()">
                            <option
                                *ngFor="let trimestre of trimestres"
                                [value]="trimestre.value">
                                {{ trimestre.name }}
                            </option>
                        </select>
                    </div>

                    <!-- Selector de Semestre (solo Pequeño) -->
                    <div class="col-md-3" *ngIf="esPequeno">
                        <label
                            for="selectSemestre"
                            class="form-label fw-semibold">
                            Semestre:
                        </label>
                        <select
                            class="form-select"
                            id="selectSemestre"
                            [(ngModel)]="selectedSemestre"
                            (change)="historyReport()">
                            <option
                                *ngFor="let semestre of semestres"
                                [value]="semestre.value">
                                {{ semestre.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div *ngIf="esGrande || esMediano || esPequeno">
                    <table class="table mt-3">
                        <thead>
                            <tr>
                                <th>Año</th>
                                <th>{{ periodoName }}</th>
                                <th>Fecha de carga</th>
                                <th>Autor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="lastReport && lastReport.anio">
                                <td>{{ lastReport.anio }}</td>
                                <td>{{ lastReport.periodo }}</td>
                                <td>{{ lastReport.fechaRegistro }}</td>
                                <td>{{ lastReport.nombreRepresentante }}</td>
                            </tr>
                            <tr
                                *ngIf="!lastReport || !lastReport.anio"
                                class="text-center">
                                <td colspan="4" class="text-muted fst-italic">
                                    No hay reportes para el periodo
                                    seleccionado.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Tab Certificados -->
            <div
                [class]="
                    showCertificados
                        ? 'tab-pane fade show active'
                        : 'tab-pane fade'
                "
                id="tabCertificadosContent"
                role="tabpanel">
                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th>Año</th>
                            <th>{{ periodoName }}</th>
                            <th>Fecha de reporte</th>
                            <th>Descarga</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="lastReport && lastReport.anio">
                            <td>{{ lastReport.anio }}</td>
                            <td>{{ lastReport.periodo }}</td>
                            <td>{{ lastReport.fechaRegistro }}</td>
                            <td>
                                <button
                                    class="btn btn-sm btn-primary"
                                    (click)="descargarCertificado()">
                                    <i class="bi bi-download"></i>
                                </button>
                            </td>
                        </tr>
                        <tr
                            *ngIf="!lastReport || !lastReport.anio"
                            class="text-center">
                            <td colspan="4" class="text-muted fst-italic">
                                No hay certificados disponibles para el periodo
                                seleccionado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #modalLoadReport>
    <div class="modal-header">
        <h5 class="modal-title">Carga masiva de ventas e inventarios</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closeMassUploadModal()"></button>
    </div>
    <div class="modal-body">
        <p class="text-muted mb-3">
            {{ 'reporte.textoModalCargaMasiva' | translate }}
        </p>
        <label for="fileInput" class="file-drop-zone">
            <div class="text-center">
                <ng-container *ngIf="!selectedFile">
                    <i
                        class="fas fa-cloud-upload-alt fa-3x text-success mb-3"></i>
                    <h5>Carga el archivo</h5>
                    <p class="small text-muted">.xlsx - Máximo 2 Mb</p>
                </ng-container>
                <ng-container
                    *ngIf="selectedFile && !filesend && !fileUploaded">
                    <i class="fas fa-file-excel fa-3x text-success mb-3"></i>
                    <p class="fw-bold mb-0">{{ selectedFile.name }}</p>
                    <p class="small text-muted">
                        {{ getFileSize(selectedFile.size) }}
                    </p>
                </ng-container>
                <ng-container *ngIf="filesend && !fileUploaded">
                    <i class="fas fa-check-circle fa-3x text-success mb-3"></i>
                    <p class="fw-bold">¡Archivo enviado!</p>
                </ng-container>
                <ng-container *ngIf="fileUploaded">
                    <i
                        class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                    <p class="fw-bold">
                        ¿Desea reemplazar el reporte anterior?
                    </p>
                </ng-container>
            </div>
            <input
                type="file"
                id="fileInput"
                class="d-none"
                (change)="onFileSelected($event)"
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        </label>
    </div>
    <div class="modal-footer justify-content-center">
        <button
            *ngIf="!fileUploaded"
            type="button"
            class="btn btn-success"
            (click)="saveMassUpload()"
            [disabled]="!selectedFile || filesend">
            Guardar
        </button>
        <button
            *ngIf="fileUploaded"
            type="button"
            class="btn btn-warning"
            (click)="replaceFile()">
            Reemplazar
        </button>
        <button
            type="button"
            class="btn btn-secondary"
            (click)="closeMassUploadModal()">
            Cancelar
        </button>
    </div>
</ng-template>
